export default {
  in_person: 'In Person',
  phone: 'Phone'
};
